import React from 'react';
import { Stack, Text, Group, Box } from '@mantine/core';
import { IEventDetails } from '../types';
import {
  IconClockHour1,
  IconMapPin,
  IconToolsKitchen2,
  IconCalendar,
  IconShoppingBag,
} from '@tabler/icons-react';
import { formatEventTime } from '../helpers';

export const EventDetails: React.FC<{
  eventDetails: IEventDetails;
}> = ({ eventDetails }) => {
  return (
    <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      {eventDetails.setupTime && (
        <Group wrap="nowrap" gap="xs" align="center">
          <IconClockHour1 size={18} />
          <Text>Setup time:</Text>
          <Text>{formatEventTime(eventDetails.setupTime ?? eventDetails.startTime)}</Text>
        </Group>
      )}
      {eventDetails.startTime && (
        <Group wrap="nowrap" gap="xs" align="center">
          <IconCalendar size={18} />
          <Text>
            Event time: {formatEventTime(eventDetails.startTime)} -{' '}
            {formatEventTime(eventDetails.endTime, 'ongoing')}
          </Text>
        </Group>
      )}
      {eventDetails.manifestTime && (
        <Group wrap="nowrap" gap="xs" align="center">
          <IconClockHour1 size={18} />
          <Text>Manifest time: {formatEventTime(eventDetails.manifestTime)}</Text>
        </Group>
      )}
      {eventDetails.readyAndBaggedTime && (
        <Group wrap="nowrap" gap="xs" align="center">
          <IconShoppingBag size={18} />
          <Text>Ready and bagged time: {formatEventTime(eventDetails.readyAndBaggedTime)}</Text>
        </Group>
      )}
      {eventDetails.locationAddress && (
        <Group wrap="nowrap" gap="xs" align="flex-start">
          <Box style={{ transform: 'translateY(2px)' }}>
            <IconMapPin size={18} />
          </Box>
          <Text>Location:</Text>
          <Text>
            {eventDetails.placeName} - {eventDetails.locationAddress}
          </Text>
        </Group>
      )}
      {eventDetails.restaurant && (
        <Group wrap="nowrap" gap="xs" align="flex-start">
          <Box style={{ transform: 'translateY(2px)' }}>
            <IconToolsKitchen2 size={18} />
          </Box>
          <Text>Restaurant:</Text>
          <Text> {eventDetails.restaurant}</Text>
        </Group>
      )}
    </Stack>
  );
};
